export const errorTypes = {
  nameEmpty: 'nameEmpty',
  conditionsEmpty: 'conditionsEmpty',
  conditionIncomplete: 'conditionIncomplete',
}

export const booleanFields = ['has_discounts']
